module.exports = __webpack_public_path__ + "static/colgadas-018.thumb-9d2700cabf259de0c38eb1f01165be99.jpg";